import React from "react";
import Cookies from "js-cookie";
import config from "../../../configs/config";
import { getLanguageSection } from "../../../shared/services/languageService";

function MediaGalleryWidget() {
  const language = getLanguageSection('home');

  const isSpanish = Cookies.get("language") === "esp";
  const mediaKitHref = isSpanish
    ? "https://marivalagents.com/es/multimedia"
    : "https://marivalagents.com/media-library";

  const resorts = [
    {
      href: mediaKitHref,
      image: `${config.publicurl}img/marival-distinct.png?v=2`,
      logo: "https://www.marivaldistinct.com/storage/logos/distinct-logo-header-bco.svg",
    },
    {
      href: mediaKitHref,
      image: `${config.publicurl}img/armony-resort.jpg?v=2`,
      logo: "https://www.marivalarmony.com/storage/logos/logo-armony-main-desktop.svg",
    },
    {
      href: mediaKitHref,
      image: `${config.publicurl}img/marival-emotions.jpg?v=2`,
      logo: "https://www.marivalemotions.com/storage/logo/logo-emotions-desktop.svg",
    },
  ];

  return (
    <div className="mr-ui">
      <h2 className="m-0 mb-4 text-lg font-normal text-marival-navy">
        {language.media}
      </h2>

      <div className="grid gap-4 md:grid-cols-3">
        {resorts.map((resort) => (
          <a
            key={resort.logo}
            target="_blank"
            rel="noreferrer"
            href={resort.href}
            className="group relative block overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition hover:-translate-y-0.5 hover:border-[#4aa6cf] hover:shadow-marival"
          >
            {/* Imagen */}
            <img
              src={resort.image}
              className="aspect-[4/3] w-full object-cover transition duration-300 group-hover:scale-[1.03]"
              alt=""
            />

            {/* Overlay oscuro */}
            <div className="absolute inset-0 bg-black/35 transition group-hover:bg-black/45" />

            {/* Logo centrado */}
            <div className="absolute inset-0 flex items-center justify-center p-6">
              <img
                src={resort.logo}
                alt=""
                className="max-h-20 w-auto drop-shadow-[0_4px_12px_rgba(0,0,0,0.8)]"
              />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default MediaGalleryWidget;
